
export default {
    name: "popup_info",
    props: [],
    data(){
        return {
            leftItems: [
                {
                    slug: "login_streak",
                    title: "Log in every day",
                    desc: "Earn <b>up to 20 MyWellness points</b> a day simply by popping in for at least seven consecutive days!"
                },
                {
                    slug: "live_stream",
                    title: "Tune in to enriching virtual talks and fitness sessions!",
                    desc: "We’ve curated a stellar line-up of speakers and insightful topics for you! Collect <b>50 MyWellness points</b> per session for watching the virtual talks live, or on demand."
                },
                {
                    slug: "matchmade",
                    title: "Up your MyWellness Matchmade game",
                    desc: "Unlock the power of building microhabits! Earn <b>10 MyWellness points per day</b> for playing, plus <b>up to 50 points per week</b> for doing well on the leaderboard!"
                },
            ],

            rightItems: [
                {
                    slug: "pick_me_up",
                    title: "Complete the MyWellness element collection!",
                    desc: "Try your luck at the MyWellness Pick-Me-Up! claw machine! Earn <b>up to 350 MyWellness points</b> as you find more adorable collectibles!"
                },
                {
                    slug: "escape_room",
                    title: "Challenge yourself at the Escape Room!",
                    desc: "Put your MyWellness knowledge to the test and “escape” from the fortnightly challenge for <b>up to 200 MyWellness points</b>!"
                },
            ]
        }
    },
    mounted(){

    },
    methods: {
    	onClickGotItBtn(){
            localStorage.setItem(`${ process.env.cookieName }_info`, true);
            this.$emit("update:currentPopupItem", null);
        }
    },
    watch: {

    }
}
